export default __webpack_public_path__ + "scripts/resources/assignments/en/Redox/redox2/assignment.json";